import { differenceInSeconds } from 'date-fns';

export default function getTimeRemaining(cutOffTime) {
  return differenceInSeconds(cutOffTime, Date.now());
}
